var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"paper"},[_c('n-link',{attrs:{"to":"/"}},[_c('Logo')],1)],1),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('footer',[_vm._v("\n\t\t© "),_c('a',{attrs:{"href":"https://www.asagroup.ie"}},[_vm._v("ASA Marketing Group")]),_vm._v(" "+_vm._s(_vm.current_year)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }